import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import WishlistMain from './WishlistMain';
import Footer from '../../components/Footer';

const Wishlist = () => {
  return (
    <>
      <HeaderSeven />

      <WishlistMain />

      <Footer />
    </>
  );
};

export default Wishlist;
